export default {
  program: require('./default_program.png'),
  closeIcon: require('./close.png'),
  addon: require('./new_addon.png'),
  logo_sekolahmu: require('./logo_sekolahmu.png'),
  icon_sekolahmu: require('./icon_sekolahmu.png'),
  voucher_icon: require('./voucher_icon.png'),
  close_input: require('./close_input.png')
}
